import styled from 'styled-components';
import { ImageSectionStyled } from '../../ImageSectionStyled';
import { rem } from 'polished';

export const ImageSectionStyledOVGB = styled(ImageSectionStyled)`
    .react-multiple-carousel__arrow {
        border-width: 2px;
        
        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.white};
            border-color: ${({ theme }) => theme.colors.primary};

            &::before {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .delivery {
        strong {
            font-weight: normal;
        }
    }
`;
